// ═══ 새 거래처 추가 시트 (대행사 W1a ③) — POST /my/malso-clients · 신청 흐름 ②와 거래처 화면(W1b)이 같이 쓴다 ═══
// 이름 필수 · 사업자등록번호·수거 주소 선택(빈 칸은 키를 보내지 않는다). 입력 상한은 onChange 에서 자른다(서버 255·50·500).
// 409 UNIT_NAME_EXISTS = 같은 이름 거래처가 이미 있음 → 그 거래처(err.body.id)를 돌려준다 — 목록 다시 읽기는 호출측.
// 그 밖 오류는 시트 안 한 줄(서버 한글 문구는 describeSimpleError 가 거른다). 열려 있을 때만 mount 한다.
// props: { accountName, agencyName, onDone(client{id,name,isSelf,joined,pickupAddress,lastRequestDate}), onClose }
import React, { useState } from 'react';
import { T } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { SheetFrame } from '../../simple/parts/ConfirmSheet';
import ErrorText from '../../simple/parts/ErrorText';
import { describeSimpleError } from '../../simple/errors';
import { Field, NoteBox, input as inputSt, btnNavy, btnDisabled } from '../../simple/screens/request/bits';
import { addMalsoClient } from '../api';

var note = { fontSize: 11.5, color: T.muted };
var submitSt = Object.assign({}, btnNavy, { width: '100%' });

function NewClientSheet(props) {
  var t = useT();
  var stF = useState({ name: '', bizNo: '', pickupAddress: '' }); var f = stF[0], setF = stF[1];
  var stBusy = useState(false); var busy = stBusy[0], setBusy = stBusy[1];
  var stErr = useState(''); var err = stErr[0], setErr = stErr[1];
  var name = f.name.trim();
  var ready = !!name && !busy;

  var edit = function (k, max) {
    return function (e) {
      var v = e.target.value.slice(0, max);
      setF(function (p) { var n = Object.assign({}, p); n[k] = v; return n; });
    };
  };
  var submit = function () {
    if (!ready) return;
    var body = { name: name };
    if (f.bizNo.trim()) body.bizNo = f.bizNo.trim();
    if (f.pickupAddress.trim()) body.pickupAddress = f.pickupAddress.trim();
    setBusy(true); setErr('');
    addMalsoClient(body).then(function (res) { props.onDone(res.client); }).catch(function (e) {
      var id = e && e.code === 'UNIT_NAME_EXISTS' ? Number(e.body && e.body.id) || 0 : 0;
      if (id) { props.onDone({ id: id, name: name, isSelf: false, joined: false, pickupAddress: '', lastRequestDate: '' }); return; }
      setBusy(false);
      setErr(describeSimpleError(t, e));
    });
  };
  var field = function (k, labelKey, max, extra) {
    return (<Field label={t(labelKey)} htmlFor={'nc-' + k}>
      <input id={'nc-' + k} style={inputSt} value={f[k]} data-testid={'nc-' + k} onChange={edit(k, max)} />
      {extra}
    </Field>);
  };

  return (<SheetFrame open title={t('malsoModeBrokerAddNew')} onClose={props.onClose} closeLabel={t('actionClose')}>
    {field('name', 'malsoModeBrokerNewName', 255)}
    {field('bizNo', 'malsoModeBrokerNewBizNo', 50)}
    {field('pickupAddress', 'malsoModeBrokerNewPickup', 500, <span style={note}>{t('malsoModeBrokerNewPickupNote')}</span>)}
    {props.agencyName ? (<NoteBox tone="accent">{t('malsoModeBrokerNewInfo', { agency: props.agencyName, broker: props.accountName })}</NoteBox>) : null}
    <ErrorText>{err}</ErrorText>
    <button type="button" style={ready ? submitSt : Object.assign({}, submitSt, btnDisabled)} disabled={!ready} data-testid="nc-submit"
      onClick={submit}>{t('malsoModeBrokerNewSubmit')}</button>
  </SheetFrame>);
}

export default NewClientSheet;
